// extracted by mini-css-extract-plugin
export default {"main":"ModalNuevaNotaAlumno_main__9xY1Z","intro":"ModalNuevaNotaAlumno_intro__bEFvr","input":"ModalNuevaNotaAlumno_input__EGMEF"};